import React, { useEffect, useState } from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import BusinessIcon from '@mui/icons-material/Business'
import SecurityIcon from '@mui/icons-material/Security'
import SaveIcon from '@mui/icons-material/Save'
import { Container } from './styled'
import { useParams } from 'react-router-dom'
import ProfileHeader from '../profileHeader/view'
import { getProfile, updateProfile, getTagsWithCategory, updateTenant } from 'api'
import {
  TextField,
  Link,
  Typography,
  Button,
  Box,
  Grid,
  Backdrop,
  CircularProgress,
  Card,
  CardContent,
  Paper,
  Alert,
  Snackbar,
  Fade
} from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useProfile } from 'context'
import noAvatar from '../../../../assets/images/no-avatar.png'
import { getAvatarUrl, getBackgroundUrl } from '../../../../api/utils'
import coworking from 'assets/images/coworking.jpg'
import { useNavigate } from 'react-router-dom'

const Profile = () => {
  const params = useParams()
  const { slug } = params
  const { profile, setProfile } = useProfile()
  const navigate = useNavigate()
  const [myProfile, setMyProfile] = useState({})

  const [tenantInfo, setTenantInfo] = useState({
    name: '',
    description: '',
    contact_email: '',
    slug: '',
  })

  const [errors, setErrors] = useState({
    link_1: false,
    link_2: false,
    link_3: false,
    post_code: false,
    phone: false
  })

  const [value, setValue] = useState("0")
  const [loading, setLoading] = useState(true)
  const [, setTags] = useState([])
  const [saveSuccess, setSaveSuccess] = useState(false)
  const [saveError, setSaveError] = useState(false)
  const [hasChanges, setHasChanges] = useState(false)


  const isValidUrl = (url) => {
    if (!url) return true // Empty is valid
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '((([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,})|' +
      'localhost|' +
      '\\d{1,3}(\\.\\d{1,3}){3})' +
      '(\\:\\d+)?(\\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$' +
      '(\\?[;&a-zA-Z0-9%_+.~#?&//=]*)?' +
      '(\\#[-a-zA-Z0-9_]*)?$'
    )
    return urlPattern.test(url)
  }

  const isValidPostCode = (postCode) => {
    if (!postCode) return true // Empty is valid
    const postCodePattern = /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i
    return postCodePattern.test(postCode)
  }

  const isValidPhoneNumber = (phone) => {
    if (!phone) return true // Empty is valid
    const phonePattern = /^(\+44|0)\d{9,10}$/
    return phonePattern.test(phone)
  }

  const handleInputChange = (key, value) => {
    setHasChanges(true)
    let isValid = true

    if (key === 'post_code') {
      isValid = isValidPostCode(value)
    } else if (key === 'phone') {
      isValid = isValidPhoneNumber(value)
    } else if (key === 'link_1' || key === 'link_2' || key === 'link_3') {
      isValid = isValidUrl(value)
    }

    setMyProfile({ ...myProfile, [key]: value })
    setErrors({ ...errors, [key]: !isValid })
  }

  const handleTenantInfoChange = (key, value) => {
    setHasChanges(true)
    setTenantInfo({ ...tenantInfo, [key]: value })
  }

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const updateTheProfile = () => {
    // Validate all fields before submission
    const hasValidationErrors = Object.values(errors).some(error => error === true)

    if (hasValidationErrors) {
      setSaveError(true)
      return
    }

    setLoading(true)
    updateProfile(myProfile)
      .then(() => {
        updateTenantInfo()

      })
      .catch(() => {
        setLoading(false)
        setSaveError(true)
      })
  }

  const updateTenantInfo = () => {

    if (!tenantInfo.slug) {
      setSaveSuccess(true)
      setLoading(false)
      return
    }
    const updateData = {
      slug: tenantInfo.slug,
      name: tenantInfo.name,
      description: tenantInfo.description,
      contact_email: tenantInfo.contact_email,
    }

    updateTenant(updateData)
      .then(() => {
        getProfileInfo()
        setHasChanges(false)
        setSaveSuccess(true)
      })
      .catch(() => {
        setLoading(false)
        setSaveError(true)
      })
  }

  function getProfileInfo() {
    setLoading(true)
    getProfile(slug)
      .then(r => {
        setProfile(r)
        // Set local component state
        setMyProfile({
          first_name: r?.first_name || '',
          last_name: r?.last_name || '',
          email: r?.email || '',
          dob: r?.dob || '',
          alias: r?.alias || '',
          avatar: r?.avatar || '',
          background: r?.background || '',
          link_1: r?.link_1 || '',
          link_2: r?.link_2 || '',
          link_3: r?.link_3 || '',
          description: r?.description || '',
          tags_need: r?.tags_need || [],
          tags_offer: r?.tags_offer || [],
          post_code: r?.post_code || '',
          single_address: r?.single_address || '',
          phone: r?.phone || '',
          work_headline: r?.work_headline || '',
          work_description: r?.work_description || '',
        })
        if (r?.tenants?.length > 0) {
          setTenantInfo({
            name: r?.tenants[0]?.name,
            description: r?.tenants[0]?.description,
            contact_email: r?.tenants[0]?.contact_email,
            slug: r?.tenants[0]?.slug,
          })
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  function getTagsInfo() {
    getTagsWithCategory(slug)
      .then(r => {
        setTags(r.tags)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getProfileInfo(true)
    getTagsInfo(true)
  }, [])

  const handleClickForgot = () => {
    navigate('/reset')
  }

  const handleSnackbarClose = () => {
    setSaveSuccess(false)
    setSaveError(false)
  }

  const avatar = getAvatarUrl(myProfile, noAvatar)
  const background = getBackgroundUrl(myProfile, coworking)

  const hasAnyErrors = Object.values(errors).some(error => error === true)

  return (
    <Container>
      {/* Profile header */}
      <ProfileHeader
        title={myProfile?.name}
        subtitle=''
        avatar={avatar}
        background={background}
        showAction={false}
        onUpdate={getProfileInfo}
        setLoading={setLoading}
      />

      <Paper elevation={0} sx={{
        borderRadius: '16px',
        overflow: 'hidden',
        backgroundColor: 'white',

        position: 'relative',
        zIndex: 1,
        mx: 2,
      }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="profile tabs"
              sx={{
                px: 2,
                pt: 2,
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '1rem',
                  minHeight: '48px',
                  px: 3
                }
              }}
            >
              <Tab
                label="Personal Info"
                value="0"
                icon={<AccountCircleIcon />}
                iconPosition="start"
              />
              <Tab
                label="Professional info"
                value="1"
                icon={<BusinessIcon />}
                iconPosition="start"
              />
              <Tab
                label="Account"
                value="4"
                icon={<SecurityIcon />}
                iconPosition="start"
              />
            </Tabs>
          </Box>

          <Box sx={{ p: 3 }}>
            {/* Tab content sections */}
            <TabPanel value="0" sx={{ p: 0, pt: 2 }}>
              <Card elevation={0} sx={{ mb: 4, border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Basic Information
                  </Typography>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Name"
                        value={myProfile?.first_name || ''}
                        onChange={(e) => handleInputChange('first_name', e.target.value)}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Surname"
                        value={myProfile?.last_name || ''}
                        onChange={(e) => handleInputChange('last_name', e.target.value)}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Email"
                        disabled
                        value={myProfile?.email || ''}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Job Title"
                        value={myProfile?.alias || ''}
                        onChange={(e) => handleInputChange('alias', e.target.value)}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ mb: 4, border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Contact Details
                  </Typography>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Post Code"
                        value={myProfile?.post_code || ''}
                        onChange={(e) => handleInputChange('post_code', e.target.value)}
                        error={errors.post_code}
                        helperText={errors.post_code ? 'Please enter a valid UK Post Code.' : ''}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Telephone"
                        value={myProfile?.phone || ''}
                        onChange={(e) => handleInputChange('phone', e.target.value)}
                        error={errors.phone}
                        helperText={errors.phone ? 'Please enter a valid UK Phone Number (starting +44 or 0).' : ''}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Address"
                        value={myProfile?.single_address || ''}
                        onChange={(e) => handleInputChange('single_address', e.target.value)}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Bio
                  </Typography>

                  <TextField
                    label="Tell us about yourself"
                    value={myProfile?.description || ''}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    multiline
                    rows={4}
                    fullWidth
                    variant="outlined"
                    placeholder="Share your background, interests, or anything you'd like others to know about you"
                  />
                </CardContent>
              </Card>
            </TabPanel>

            <TabPanel value="1" sx={{ p: 0, pt: 2 }}>
              <Card elevation={0} sx={{ mb: 4, border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Professional Links
                  </Typography>

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Contact Link"
                        value={myProfile.link_1 || ''}
                        onChange={(e) => handleInputChange('link_1', e.target.value)}
                        error={errors.link_1}
                        helperText={errors.link_1 ? 'Please enter a valid URL.' : 'Add your preferred contact link (LinkedIn, Calendly...)'}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Project Link"
                        value={myProfile.link_2 || ''}
                        onChange={(e) => handleInputChange('link_2', e.target.value)}
                        error={errors.link_2}
                        helperText={errors.link_2 ? 'Please enter a valid URL.' : 'Add a link with your main project (LinkedIn, Instagram, Personal website...)'}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Other Link"
                        value={myProfile.link_3 || ''}
                        onChange={(e) => handleInputChange('link_3', e.target.value)}
                        error={errors.link_3}
                        helperText={errors.link_3 ? 'Please enter a valid URL.' : 'Add any other relevant link you want to share.'}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Your Work
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="Where do you work?"
                        value={myProfile?.work_headline || ''}
                        onChange={(e) => handleInputChange('work_headline', e.target.value)}
                        multiline
                        fullWidth
                        variant="outlined"
                        placeholder="Mention the company, organization, or type of work environment you are associated with"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="What do you do?"
                        value={myProfile?.work_description || ''}
                        onChange={(e) => handleInputChange('work_description', e.target.value)}
                        multiline
                        rows={4}
                        fullWidth
                        variant="outlined"
                        placeholder="Describe your main work, role, or what you do professionally"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </TabPanel>

            <TabPanel value="4" sx={{ p: 0, pt: 2 }}>
              <Card elevation={0} sx={{ mb: 4, border: '1px solid', borderColor: 'divider', borderRadius: '12px' }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                    Reset Password
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 3 }}>
                    If you forgot your password or want to change it for security reasons, you can reset it by clicking the button below.
                  </Typography>

                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClickForgot}
                    size="large"
                  >
                    Reset Password
                  </Button>
                </CardContent>
              </Card>

              <Card elevation={0} sx={{
                border: '1px solid',
                borderColor: 'error.light',
                borderRadius: '12px',
                backgroundColor: 'error.lighter'
              }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, color: 'error.main' }}>
                    Delete Account
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    To permanently delete your account, please send us an email at{' '}
                    <Link href="mailto:hello@hivespace.co" sx={{ fontWeight: 500 }}>
                      hello@hivespace.co
                    </Link>.
                  </Typography>

                  <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    Make sure to include the following details in your email:
                  </Typography>

                  <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                    <Box component="li">
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Your full name
                      </Typography>
                    </Box>
                    <Box component="li">
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        The email address associated with your account
                      </Typography>
                    </Box>
                    <Box component="li">
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        A short reason for deleting the account (optional)
                      </Typography>
                    </Box>
                    <Box component="li">
                      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        A confirmation that you understand account deletion is permanent
                      </Typography>
                    </Box>
                  </Box>

                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Once we receive your email, we will process your request within a few business days.
                  </Typography>
                </CardContent>
              </Card>
            </TabPanel>
          </Box>

          <Box sx={{
            position: 'sticky',
            bottom: 0,
            width: '100%',
            p: 2,
            backgroundColor: 'white',
            borderTop: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            zIndex: 2
          }}>
            <Button
              variant="contained"
              color="primary"
              onClick={updateTheProfile}
              disabled={!hasChanges || hasAnyErrors}
              size="large"
              startIcon={<SaveIcon />}
              sx={{ borderRadius: '8px', px: 3 }}
            >
              Save Changes
            </Button>
          </Box>
        </TabContext>
      </Paper>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Success Snackbar */}
      <Snackbar
        open={saveSuccess}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        TransitionComponent={Fade}
      >
        <Alert severity="success" variant="filled" onClose={handleSnackbarClose}>
          Profile updated successfully!
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={saveError}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        TransitionComponent={Fade}
      >
        <Alert severity="error" variant="filled" onClose={handleSnackbarClose}>
          There was an error updating your profile. Please check the form and try again.
        </Alert>
      </Snackbar>
    </Container>
  )
}

export default Profile